<template>
  <div class="space-between-y">
    <div class="container-left space-between-x">
      <input-item label="请输入关键字进行搜索">
        <el-input v-model="form.keyword" placeholder="请输入关键字"></el-input>
      </input-item>

      <input-item>
        <el-button @click="getList" type="primary">搜索</el-button>
      </input-item>
    </div>

    <el-table :data="list" stripe border>
      <el-table-column width="180" show-overflow-tooltip prop="logTime" label="时间">
        <template v-slot="scope">
          {{ utils.date.format(scope.row.logTime) }}
        </template>
      </el-table-column>
      <el-table-column show-overflow-tooltip prop="url" label="URL"></el-table-column>
      <el-table-column show-overflow-tooltip prop="userName" label="用户名"></el-table-column>
      <el-table-column show-overflow-tooltip prop="ipAddress" label="请求IP"></el-table-column>
      <el-table-column show-overflow-tooltip prop="responseSize" label="响应体大小"></el-table-column>
      <el-table-column show-overflow-tooltip prop="client" label="请求来源"></el-table-column>
      <el-table-column show-overflow-tooltip prop="clientUrl" label="用户所在页URL"></el-table-column>
      <el-table-column show-overflow-tooltip prop="executionTime" label="请求执行时间"></el-table-column>
      <el-table-column show-overflow-tooltip prop="queryParams" label="请求参数"></el-table-column>
    </el-table>

    <pagination v-model="page" @updated="getList()"></pagination>

  </div>
</template>

<script>
import Pagination from "@/components/base/layout/Pagination.vue";
import {sys} from "@/api/sys";
import InputItem from "@/components/base/layout/InputItem.vue";
import {utils} from "@/util/utils";

export default {
  name: 'LogHttp',
  computed: {
    utils() {
      return utils
    }
  },
  components: {InputItem, Pagination},

  data() {
    return {
      form: {
        keyword: "",
      },

      page: {
        size: 10,
        current: 1,
        total: 0,
      },

      list: [],

      isLoading: false,
    };
  },

  created() {
    this.getList();
  },

  methods: {
    getList(current) {

      if (current === null) {
        this.page.current = 1;
      }

      sys.listLogHttp(this.page.size, this.page.current, this.form.keyword).then(res => {
        let page = res.data;
        this.list = page?.list;
        this.page.total = page?.total;
      })
    },
  },

}
</script>

<style scoped>

</style>